import { useCallback, useEffect, useState } from 'react'

import useRedux from '../../../hooks/useRedux'
import { setEquipmentData } from '../../../redux/jobs/action'
import debounce from '../../../utils/debounce'
import { isEqual, notEqual, ternary } from '../../../utils/javascript'
import { hasOnlySpace } from '../../../utils/validation'
import { getEquipmentApi, searchEquipmentApi } from '../jobs.api'

const equipmentSelect = ({ index }) => {
  const { dispatch, selector } = useRedux()
  const equipmentState = selector(state => state?.jobs?.equipment?.selected)
  const equipmentSelected = equipmentState?.[index]
  const { userEinId, equipmentIdentificationNumberFreeText, selectedOption } = {
    ...equipmentSelected,
  }
  const selectedValue = userEinId || equipmentIdentificationNumberFreeText
  const [options, setOptions] = useState([])
  const [isDisable, setIsDisable] = useState(false)
  const [search, setSearch] = useState('')
  const [isOpen, setIsOpen] = useState(false)
  const pageSize = 10

  useEffect(() => {
    getSelectOptions({})
  }, [])

  const getSelectOptions = async ({ pageNo = 1, searchValue, options }) => {
    setOptions({ ...options, loader: true })
    const params = `${pageNo}?pageSize=${pageSize}`
    let resp
    if (searchValue) {
      resp = await searchEquipmentApi({
        params: `${params}&name=${searchValue}`,
      })
    } else {
      resp = await getEquipmentApi({ params })
    }
    setOptions({
      ...resp?.data,
      loader: false,
      list: [
        ...((notEqual(pageNo, 1) && options?.list) || []),
        ...(resp?.data?.list || []),
      ],
    })
    if (isDisable) setIsDisable(false)
  }

  const debounceGetOptions = useCallback(debounce(getSelectOptions, 500), [])

  const handleOnChange = (value, option) => {
    const isCustom = isEqual(typeof value, 'string')
    const payload = {
      userEinId: ternary(isCustom, null, value),
      equipmentIdentificationNumberFreeText: ternary(isCustom, value, null),
      selectedOption: option,
    }
    dispatch(setEquipmentData(payload, index))
  }

  const onInputSearch = async e => {
    const { value } = e?.target
    setIsDisable(true)
    setSearch(value)
    !hasOnlySpace(value) && debounceGetOptions({ searchValue: value, options })
  }

  const handleAddNewItem = () => {
    if (search?.trim()) {
      dispatch(
        setEquipmentData(
          {
            userEinId: null,
            equipmentIdentificationNumberFreeText: search,
            selectedOption: { label: search, value: search },
          },
          index,
        ),
      )
      setOptions({
        ...options,
        list: [{ name: search, id: search }, ...(options?.list || [])],
      })
    }

    setSearch('')
    setIsOpen(false)
    getSelectOptions({})
  }

  const onDropdownVisible = visible => setIsOpen(visible)

  const onScroll = debounce(e => {
    if (isDisable) return
    const { target } = e
    const { pageNo, hasMore } = { ...options }
    if (
      hasMore &&
      isEqual(target.scrollHeight - target.scrollTop, target.clientHeight)
    ) {
      getSelectOptions({ pageNo: pageNo + 1, searchValue: search, options })
    }
  }, 300)

  const modifyForOptions = list => {
    const newList = []
    list?.forEach(({ name, id }) => {
      if (isEqual(selectedOption?.value, id) && !search?.trim()) return
      newList.push({
        label: name,
        value: id,
      })
    })
    return ternary(
      selectedOption?.value && !search?.trim(),
      [selectedOption, ...newList],
      newList,
    )
  }

  return {
    isOpen,
    search,
    selectedValue,
    options,
    modifyForOptions,
    onInputSearch,
    onScroll,
    handleOnChange,
    handleAddNewItem,
    onDropdownVisible,
  }
}

export default equipmentSelect
